// === api/BookMark.ts (corrigido) ===
import { IBookmark } from "../hooks/useBookmark";
import { IContact } from "../types/contacts";
import { apiCore, ApiResponse } from "./apiCore";
import * as url from "./urls";

export const getBookmarks = () => {
  return apiCore(url.BOOKMARK, {
    method: "GET",
  });
};

export const getMarkedContact = async (id: number): Promise<IContact[]> => {
  const response = await apiCore<IContact[]>(
    `${url.BOOKMARK}/${id}/Contact?TypeMark=1`,
    {
      method: "GET",
    },
  );

  // console.log("getmarkedContact", response.data);
  return response.data; // 👈 agora sim
};

export const getBlockedContact = async (id: number): Promise<IContact[]> => {
  const response = await apiCore<IContact[]>(
    `${url.BOOKMARK}/${id}/Contact?TypeMark=2`,
    {
      method: "GET",
    },
  );

  // console.log("getBlockedContact", response.data);
  return response.data; // 👈 agora sim
};

export const getBookmarkContact = async (id: number): Promise<IContact[]> => {
  const response = await apiCore<IContact[]>(
    `${url.BOOKMARK}/${id}/Contact?TypeMark=0`,
    {
      method: "GET",
    },
  );

  // console.log("getBookmarkContact", response.data);
  return response.data; // 👈 agora sim
};

export const getBookmarkUser = async (id: number): Promise<IBookmark[]> => {
  const response = await apiCore<IBookmark[]>(`${url.BOOKMARK}/${id}/Contact`, {
    method: "GET",
  });

  // console.log("getBookmarkUser", response.data);
  return response.data; // 👈 agora sim
};

export const deleteBookmark = (idUser: number, idContact: number) => {
  return apiCore(`${url.BOOKMARK}/${idUser}/${idContact}`, {
    method: "DELETE",
  });
};

export const updateBookmark = (data: object) => {
  return apiCore(url.BOOKMARK, {
    method: "PUT",
    body: data,
  });
};

export const createBookmark = (data: object) => {
  return apiCore(url.BOOKMARK, {
    method: "POST",
    body: data,
  });
};
